
import React from "react";
import { RefreshCw, AlertTriangle, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TrainingErrorDisplayProps {
  onReload: () => void;
  message?: string;
  showRefreshPage?: boolean;
  showContactSupport?: boolean;
  details?: string;
  url?: string;
}

export function TrainingErrorDisplay({ 
  onReload, 
  message = "There was a problem loading the training materials. Please try again.",
  showRefreshPage = true,
  showContactSupport = false,
  details,
  url
}: TrainingErrorDisplayProps) {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="p-6 text-center max-w-lg">
        <AlertTriangle className="h-10 w-10 text-red-500 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-red-600 mb-2">Error Loading Training</h3>
        <p className="text-gray-600 mb-4">
          {message}
        </p>
        
        {url && (
          <div className="bg-gray-100 p-3 mb-4 rounded text-xs text-left">
            <p className="text-gray-500 mb-1">Source URL:</p>
            <code className="text-gray-700 break-all whitespace-pre-wrap">{url}</code>
          </div>
        )}
        
        {details && (
          <div className="bg-gray-100 p-3 mb-4 rounded text-sm text-left">
            <p className="text-xs text-gray-500 mb-1">Technical details:</p>
            <code className="text-xs text-gray-700 break-all whitespace-pre-wrap">{details}</code>
          </div>
        )}
        
        <div className="flex flex-wrap gap-3 justify-center">
          <Button
            onClick={onReload}
            className="flex items-center gap-2"
            variant="outline"
          >
            <RefreshCw className="h-4 w-4" />
            Reload Content
          </Button>
          
          {showRefreshPage && (
            <Button
              onClick={() => window.location.reload()}
              variant="default"
            >
              Refresh Page
            </Button>
          )}
          
          {showContactSupport && (
            <Button
              variant="secondary"
              className="flex items-center gap-2"
              onClick={() => window.open('mailto:support@example.com', '_blank')}
            >
              <ExternalLink className="h-4 w-4" />
              Contact Support
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
